import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './index.css';
import Providers from './providers';
import './auth';

if (
  process.env.NODE_ENV !== 'development' &&
  process.env.REACT_APP_DD_APPLICATION_ID &&
  process.env.REACT_APP_DD_CLIENT_TOKEN
) {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DD_APPLICATION_ID,
    clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'exos-web',
    env: process.env.REACT_APP_ENV_LEVEL,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    traceSampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask',
  });
  datadogLogs.init({
    clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'exos-web',
    env: process.env.REACT_APP_ENV_LEVEL,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });
}

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>,
);
